import { Edit, Trash } from 'lucide-react';
import React from 'react'
import BtnSpinner from '../../components/BtnSpinner';
import Pagination from '../../components/Pagination';
import moment from 'moment';

function CommonLeadsTable({total, leads, handleDelete,loading,currentPage,totalItems,itemsPerPage,handlePageChange,deleteId }) {
    return (
        <main className="mx-auto py-6 sm:px-6 lg:px-8">
            <div className="px-4 py-6 sm:px-0">
                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white">
                        <thead className="bg-gray-50 text-center">
                            <tr>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Whatsapp Number</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Country</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Country Code</th>
                                {/* <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Chapters</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Validity</th> */}
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Created At</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 text-center">
                            {leads?.map((lead) => (
                                <tr key={lead?._id}>

                                    {/* <td className="px-6 py-4 whitespace-nowrap"><span className='text-indigo-600 cursor-pointer' onClick={() => { setIsOffCanvasOpen({ state: true, name: "viewcourse" }); setCurrentCourse(course) }}>{course?.course_id}</span></td> */}
                                    <td className="px-6 py-4 whitespace-nowrap">{lead?.name}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{lead?.email}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{lead?.whatsapp_number}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{lead?.notes?.country}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{lead?.notes?.country_code}</td>
                                    {/* <td className="px-6 py-4 whitespace-nowrap">{course?.notes?.validity || "Lifetime"}</td> */}
                                    <td className="px-6 py-4 whitespace-nowrap">{moment(lead?.createdAt).format("DD-MM-YY hh:mm a")}</td>
                                    <td className="px-6 py-4 flex gap-5 justify-center">
                                        {/* <button className='flex bg-indigo-400 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "editcourse" }); setCurrentCourse(course) }}>
                                            <Edit className='text-white' size={20} />
                                            <span className='text-white text-sm'>Edit</span>
                                        </button> */}
                                        <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => handleDelete(lead?._id)}>
                                            {
                                                loading.state && loading.name === "deletelead" && deleteId === lead?._id ?
                                                    <BtnSpinner /> :
                                                    <>
                                                        <Trash className='text-red-700 text-sm' size={20} />
                                                        <span className='text-red-700 text-sm'>Delete</span>
                                                    </>
                                            }

                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {leads?.length ?
                <div className="flex gap-x-2 items-center justify-between">
                    <p>Total: {totalItems}</p>
                    <Pagination
                        page={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        onPageChange={handlePageChange}
                    />
                </div> : null}
        </main>
    )
}

export default CommonLeadsTable